<template>
  <div class="datepicker">
    <flat-pickr
      class="flatpickr-input"
      :value="modelValue"
      :config="config"
      :placeholder="placeholder"
      :required="isRequired"
      @input="updateValue($event.target.value)"
    ></flat-pickr>
  </div>
</template>

<script>
import FlatPickr from "vue-flatpickr-component";
import "flatpickr/dist/flatpickr.css";

export default {
  components: {
    FlatPickr,
  },
  props: {
    modelValue: {
      type: String,
      default: "",
    },
    placeholder: {
      type: String,
      default: "",
    },
    isRequired: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      config: {
        altInput: true,
        altFormat: "j. F Y",
        dateFormat: "Y-m-d",
      },
    };
  },
  methods: {
    updateValue(value) {
      this.$emit("update:modelValue", value);
    },
  },
};
</script>
